var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09096 0L6.66407 3.11178L10.1819 3.61384L7.63644 6.03466L8.23717 9.45464L5.09096 7.8391L1.94475 9.45464L2.54548 6.03466L0 3.61384L3.51785 3.11178L5.09096 0Z",
    fill: "#318BEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.726 5.81836L16.2093 12.76L23.9988 13.88L18.3624 19.2803L19.6926 26.9095L12.726 23.3056L5.75935 26.9095L7.08954 19.2803L1.45312 13.88L9.24266 12.76L12.726 5.81836Z",
    fill: "#318BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.2f65f0a802f61a8351d6ebe7f0ca85ff.svg";
export { ForwardRef as ReactComponent };